<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="msg-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">

                    <div class="goods-detail">
                        <div class="goods-wrapper">
                            <div class="goods-pic" v-tips="giftId"><game-item :locked="true" :id="giftId" :num="-1"></game-item></div>
                        </div>  
                    </div>                    

                    <div class="msg-view">
                        <p>成功帮砍<em class="icon-m3b"></em>{{ amt }}，够兄弟！</p>
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn ok" @click="closeModal"></div>
                        <!-- <div class="u-btn cancel" @click="closeModal"></div> -->
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style scoped>
.msg-modal{
    position: relative;
    width: 625px;
    height: 365px;
    font-size: 24px;
    color: #3d3e43;
    background-image: url(~@/assets/images/modal/bg-modal-order.png);
}

.dialog-wrapper{
    padding-top: 40px;
}

.goods-wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 118px;
    height: 118px;
    margin: 0 auto;
    background-image: url(~@/assets/images/shop/bg-item.png);
}

.goods-pic{
    width: 69px;
    height: 69px;
}

.msg-view{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    /* position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%,-40%); */
    /* width: 666px;
    height: 137px;
    margin: 20px auto;
    background-image: url(~@/assets/images/bg-msg.png);
    color: #8e492e; */
}

.msg-view p{
    padding: 0 36px;
    line-height: 1.8;
}

.msg-view b{
    color: #fe5a1e;
}

.u-ctrl{
    position: absolute;
    left: 50%;
    bottom: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateX(-50%);
}

.u-ctrl .u-btn.ok{
    width: 186px;
    height: 56px;
    background-image: url(~@/assets/images/modal/btn-submit.png);    
}


</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            giftId : 'A001',
            amt : 0,
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        //this.$be_busy();
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>